import {
  DataContainer,
  PaginatedList,
  PaginatedListProps,
  Table,
  TableColumnProps,
} from '@acme/foundation';

export type OperationsTableProps<T> = {
  columns: TableColumnProps<T>[];
  method: PaginatedListProps<
    T,
    null,
    { data: { items: T[]; totalCount: number } }
  >['method'];
};

export const OperationsTable = <T extends object = object>(
  props: OperationsTableProps<T>
) => {
  return (
    <PaginatedList
      className="!gap-0"
      classNamePagination="px-4 pb-4"
      method={props.method}
      extract={(response) => ({
        items: response.data?.items || [],
        totalCount: response.data?.totalCount,
      })}
      loadingFallback={
        <div className="bg-white border border-gray-200 rounded-lg p-12 text-center text-gray-500">
          Загрузка…
        </div>
      }
    >
      {(items) => (
        <DataContainer
          className="min-h-[624px]"
          empty={{
            view: !items.length,
            title: 'Операции по заданным условиям не найдены',
          }}
        >
          <Table
            keyIndex="id"
            columns={props.columns}
            data={items}
            className="rounded-b-none border-b-none"
          />
        </DataContainer>
      )}
    </PaginatedList>
  );
};
